import { Box, Typography } from '@mui/material';
import { Secret } from 'api/model';
import SecretIcon from 'views/secrets/SecretIcon';
import ScopeIndicator from 'components/indicators/ScopeIndicator';

type SecretRendererProps = {
  secret?: Secret;
  fallback: string;
};

const SecretRenderer = ({ secret, fallback }: SecretRendererProps) => {
  if (!secret) return <span>{fallback}</span>;

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
      <Box display="flex" gap={1} alignItems="center" className="flex">
        <SecretIcon type={secret.type} scale={0.6} />
        <span>{secret.name}</span>
        <ScopeIndicator isGlobal={secret.project_id == null} />
      </Box>
      <Typography variant="body2" color="text.disabled">
        {secret.value.length > 24 ? `${secret.value.slice(0, 12)}${secret.value.slice(-12)}` : secret.value}
      </Typography>
    </Box>
  );
};

export default SecretRenderer;
